import { action, observable, reaction, makeObservable } from 'mobx';
import {
  contentLoaders,
  ContentLookup,
  contentLookupService,
  VersionedContentLookup,
  X5Lesson,
  X6Page
} from '../../../domain';
import {arrayToMap, Disposers, HttpPromiseState, PromiseState} from '../../../lib/helpers';

export class X5LessonLoader {
  @observable.ref
  lookupState: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  lookup: ContentLookup | null;

  @observable.ref
  lessonState: HttpPromiseState<X5Lesson> | null;
  @observable.ref
  lesson: X5Lesson | null;
  @observable.ref
  pages: readonly X6Page[];
  @observable.ref
  pageById: { [index: number]: X6Page };

  private readonly disposers = new Disposers();

  constructor(readonly lessonId: number) {
    makeObservable(this);
    this.lookupState = null;
    this.lookup = null;
    this.lessonState = null;
    this.lesson = null;
    this.pages = [];
    this.pageById = {};
    this.setup();
  }

  @action
  loadLookup = () => {
    if (this.lookupState?.isPending === true)
      return;
    this.lookupState = contentLookupService.load();
  };

  @action
  refreshLookup = () => {
    if (this.lookupState?.isPending === true)
      return;
    this.lookupState = contentLookupService.refresh();
  };

  @action
  loadLesson = () => {
    if (this.lessonState?.isPending === true)
      return;
    this.lessonState = contentLoaders.x5lesson.get(this.lessonId);
  };

  private setup() {
    this.disposers.add(
      reaction(
        () => this.lookupState?.state,
        this.onLookupStateChange),
      reaction(
        () => this.lessonState?.state,
        this.onLessonStateChange));
  }

  @action
  private onLookupStateChange = () => {
    this.lookup = null;
    if (this.lookupState?.isResolved === true)
      this.lookup = this.lookupState.value.lookup;
  };

  @action
  private onLessonStateChange = () => {
    this.lesson = null;
    this.pages = [];
    this.pageById = {};
    if (this.lessonState?.isResolved === true) {
      let lesson = this.lesson = this.lessonState.value;
      let pages = this.pages = lesson.Pages ?? [];
      this.pageById = arrayToMap(pages, x => x.Id);
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
